export const PREFERENCES_DEFAULTS = {
	editorMode: 'visual',
	isGeneralSidebarDismissed: false,
	panels: {
		'post-status': {
			opened: true,
		},
	},
	features: {
		fixedToolbar: false,
	},
	pinnedPluginItems: {},
};
